<template>
  <div class="form_text">
    <h1>洽詢方式：</h1>
    <h4>電話：(03) 657-3989</h4>
    <h4>傳真：(03) 657-3889</h4>
    <h4>電子郵件：3a.judy@3farms.com.tw</h4>
    <h4>地址：新竹縣竹北市縣政二路488號2樓</h4>
  </div>
</template>

<script>

export default {
  data() {
    return {
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.form_text{
  h1{
    display: inline-block;
    border-bottom: solid 2px #212529;
    padding-bottom: 10px;
    margin-bottom: 40px;
  }
}

@media screen and (max-width: 800px){
  .form_text{
    h1{
      font-size: 2rem;
    }
    h4{
      font-size: 1rem;
    }
  }
}
</style>
